module.exports = __webpack_public_path__ + "img/apple-core.906174d6.svg";